<template>
  <div class="active_table" ref="content">
    <toolbar>
      <div class="search">
        <!-- 企业选择 -->
        <div class="label">企业名称：</div>
        <Select
          v-model="uuid"
          style="width: 7.8em;margin-right:1em;"
          @on-change="getRtuEnum"
          placeholder="请选择企业"
          clearable
        >
          <Option v-for="item in companyList" :value="item.uuid" :key="item.id">{{ item.name }}</Option>
        </Select>
        <!-- rtu选择 -->
        <div class="label">分组名称：</div>
        <Select v-model="search.rtuCode" style="width: 7.8em" placeholder="请选择分组" clearable>
          <Option v-for="item in rtuList" :value="item.code" :key="item.id">{{ item.name }}</Option>
        </Select>
        <DatePicker
          type="daterange"
          placement="bottom-end"
          placeholder="选择日期"
          style="width: 200px;margin-left: 10px"
          @on-change="dateSelect($event)"
        ></DatePicker>
        <Select
          v-model="search.timeSegmentation"
          clearable
          style="width:100px;margin-left:10px;text-align:center;"
        >
          <Option
            v-for="item in timeSegmentationList"
            :key="item.value"
            :value="item.value"
          >{{ item.name }}</Option>
        </Select>
        <i-button type="default" @click="searchFunc" style="margin-left: 1em;">搜索</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :height="table.maxHeight" :data="table.data"></i-table>
      <Page
        :total="table.total"
        show-sizer
        :page-size="40"
        @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)"
        style="text-align:right;margin-top: 1em"
      />
      <Spin fix v-show="table.loading"></Spin>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
  padding-top: 2em;
}
.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}
.content {
  width: 700px;
  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../../../p_company/components/toolBar.vue"; // 操作栏组件
import { timeStamp } from "../../../util/common/date"; // 时间转化工具
import { emComputed } from "../../../util/common/fontSize"; // em转化工具
import { Resize } from "../../../util/common/resize";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            title: "ai0",
            key: "ai0",
            align: "center"
          },
          {
            title: "ai1",
            key: "ai1",
            align: "center"
          },
          {
            title: "ai2",
            key: "ai2",
            align: "center"
          },
          {
            title: "ai3",
            key: "ai3",
            align: "center"
          },
          {
            title: "ai4",
            key: "ai4",
            align: "center"
          },
          {
            title: "ai5",
            key: "ai5",
            align: "center"
          },
          {
            title: "ai6",
            key: "ai6",
            align: "center"
          },
          {
            title: "ai7",
            key: "ai7",
            align: "center"
          },
          {
            title: "日期",
            key: "createDate",
            width: 180,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  timeStamp(params.row.createDate, "yyyy-MM-dd HH:mm")
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 40,
        total: 0,
        loading: true,
        maxHeight: null
      },
      // 查询
      search: {
        rtuCode: null,
        startDate: new Date().setHours("0"),
        endDate: new Date().getTime(),
        timeSegmentation: null
      },
      rtuList: [], // rtu枚举列表
      timeSegmentationList: [
        {
          name: "每分钟",
          value: 60
        },
        {
          name: "每十分钟",
          value: 600
        },
        {
          name: "每小时",
          value: 3600
        }
      ],
      // 企业列表
      companyList: [],
      // 当前企业
      uuid: null
    };
  },
  components: {
    toolbar
  },
  created: async function() {
    await this.getCompany(); // 获取企业列表
    this.getRtuEnum(); // 获取rtu端口对应设备 渲染表头 数据初始化
    this.tableInit(); // 表格初始化
    window.addEventListener("resize", this.tableInit);
  },
  methods: {
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Report.getReportList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuids", "park"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    // 搜索
    searchFunc() {
      this.getRtuDevice();
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    // 获取rtu枚举值
    getRtuEnum() {
      this.$api.Enum.getRtuEnum({ content: { uuid: this.uuid } }, [
        null,
        "park"
      ]).then(res => {
        if (res.code == 0) {
          this.rtuList = res.data;
          if (this.rtuList.length == 0) {
            // 当没有rtu的情况下
            this.getData();
            return;
          }
          // 获取枚举数据后 默认选择第一个枚举查rtu端口对应设备
          if (this.rtuList.length != 0) {
            this.search.code = this.rtuList[0].code;
            this.search.rtuCode = this.rtuList[0].code;
            this.getRtuDevice();
          }
        } else {
          this.$Notice.warning({
            title: "获取分组枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取rtu 8个端口对应的设备
    getRtuDevice() {
      this.$api.Deploy.getRtuList({ content: { code: this.search.rtuCode } }, [
        "uuids",
        "park"
      ]).then(res => {
        if (res.code == 0 && res.data.list.length != 0) {
          let data = res.data.list[0];
          let columns = [];
          for (let i = 0; i < 9; i++) {
            columns[i] = {};
            if (data["aI" + i + "DeviceName"]) {
              columns[i].title = data["aI" + i + "DeviceName"];
            } else {
              columns[i].title = "aI" + i;
            }
            columns[i].align = "center";
            columns[i].key = `ai${i}`;
          }
          columns[columns.length - 1] = {
            title: "日期",
            key: "createDate",
            width: 180,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  timeStamp(params.row.createDate, "yyyy-MM-dd HH:mm")
                )
              ]);
            }
          };
          this.table.columns = columns;
          this.getData(); // 渲染好表头后加载数据
        } else {
          this.$Notice.warning({
            title: "获取端口对应设备失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 选择时间
    dateSelect(date) {
      this.search.startDate = new Date(date[0]).setHours("0");
      this.search.endDate = new Date(date[1]).setHours("24");
    },
    // 表格高度计算
    tableInit() {
      this.$nextTick(() => {
        if (this.$route.path != "/ahome/current") {
          window.removeEventListener("resize", this.tableInit);
          return false;
        }
        let tableH = this.$refs.content.clientHeight;
        let headerH = emComputed(9.5); // 操作栏5.5em转换px， 2em的上下边距分页组件
        this.table.maxHeight = tableH - headerH - 32; // 32px的分页组件高度
      });
    },
    // 获取企业列表
    getCompany() {
      return new Promise((resolve, reject) => {
        this.$api.A_Company.getCompanyHomeList(null, ["uuids", "park"]).then(
          res => {
            if (res.code == 0) {
              let data = res.data;
              this.companyList = data;
              this.uuid = data[0].uuid;
              resolve();
            } else {
              this.$Notice.warning({
                title: "获取企业列表失败",
                desc: res.message || "请联系管理员"
              });
            }
          }
        );
      });
    }
  }
};
</script>